import React from 'react';
export const WarningIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-117">
    <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-id="element-118"></path>
    <line x1="12" y1="9" x2="12" y2="13" data-id="element-119"></line>
    <line x1="12" y1="17" x2="12.01" y2="17" data-id="element-120"></line>
  </svg>;
export const MoonIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-121">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" data-id="element-122"></path>
  </svg>;
export const FlameIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-123">
    <path d="M8.5 14.5A2.5 2.5 0 0011 12c0-1.38-.5-2-1-3-1.072-2.143-.224-4.054 2-6 .5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a7 7 0 11-14 0c0-1.153.433-2.294 1-3a2.5 2.5 0 002.5 2.5z" data-id="element-124"></path>
  </svg>;
export const BrainIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-125">
    <path d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 1.98-3A2.5 2.5 0 0 1 9.5 2Z" data-id="element-126"></path>
    <path d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-1.98-3A2.5 2.5 0 0 0 14.5 2Z" data-id="element-127"></path>
  </svg>;
export const LeafIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-128">
    <path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z" data-id="element-129"></path>
    <path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12" data-id="element-130"></path>
  </svg>;
export const LotusIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-131">
    <path d="M12 22c-4.4 0-8-3.6-8-8s8-12 8-12 8 7.6 8 12-3.6 8-8 8z" data-id="element-132"></path>
    <path d="M12 22c-2.2 0-4-3.6-4-8s4-12 4-12 4 7.6 4 12-1.8 8-4 8z" data-id="element-133"></path>
    <path d="M12 22v-8" data-id="element-134"></path>
  </svg>;
export const CheckIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-135">
    <polyline points="20 6 9 17 4 12" data-id="element-136"></polyline>
  </svg>;
export const ShieldIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" data-id="element-137">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" data-id="element-138"></path>
  </svg>;
export const StarIcon = ({
  className = 'w-6 h-6'
}) => <svg className={className} viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round" data-id="element-139">
    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" data-id="element-140"></polygon>
  </svg>;
export const SectionDivider = () => <div className="flex justify-center items-center py-3 opacity-30" data-id="element-141">
    <div className="h-px w-16 bg-brand-green" data-id="element-142"></div>
    <LeafIcon className="w-6 h-6 mx-4 text-brand-green" data-id="element-143" />
    <div className="h-px w-16 bg-brand-green" data-id="element-144"></div>
  </div>;